import React from 'react'
import styled, { css } from 'styled-components'
import { ReactComponent as OverviewIcon } from 'libs/shared/assets/src/lib/icons/overviewIcon.svg'
import { useTranslation } from 'react-i18next'

const Wrapper = styled.div(({ theme: { palette } }) => css`
  background-color: ${palette.product.overview.sidebarButtonBg};
  color: ${palette.product.overview.main};
  padding: 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  border-radius: 10px;
  cursor: pointer;
  margin: 0 1rem 0.5rem 0;
`)

export function OverviewSidebarButton(): JSX.Element {
  const { t } = useTranslation()

  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }
  return (
    <Wrapper onClick={handleClick}>
      <OverviewIcon />
      {t('placeme.overview.title')}
    </Wrapper>
  )
}
